import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openNotification } from "src/components/helpers/notification";
import ax from "src/store/config";

const initialState = {
  packetsTrainingsList: null,
  packetsTrainingsListLoading: false,
};

export const packetsTrainingsAction = createAsyncThunk(
  "packetsTrainingsAction",
  async (payload, { dispatch }) => {
    dispatch(setPacketsTrainingsListLoading(true));
    try {
      let data;
      switch (payload.flag) {
        case "get":
          ({ data } = await ax.get("api/admin/directory/personalPackets", {
            params: payload.value,
          }));
          data && dispatch(setPacketsTrainingsListLoading(false));
          return data;

        case "post":
          ({ data } = await ax.post(
            "api/admin/directory/editPersonalPacket",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно отредактирован`,
            });
          break;

        case "put":
          ({ data } = await ax.put(
            "api/admin/directory/addPersonalPacket",
            payload.value
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно добавлен`,
            });
          break;

        case "delete":
          ({ data } = await ax.delete(
            "api/admin/directory/deletePersonalPacket",
            { params: payload.value }
          ));
          data &&
            openNotification({
              type: "success",
              message: `Пакет успешно удален`,
            });
          break;

        default:
          break;
      }
    } catch (error) {
      dispatch(setPacketsTrainingsListLoading(false));
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
      return error;
    }
  }
);

const PacketsTrainingsSlice = createSlice({
  name: "packetsTrainings",
  initialState,
  reducers: {
    setPacketsTrainingsListLoading: (state, action) => {
      state.packetsTrainingsListLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(packetsTrainingsAction.fulfilled, (state, action) => {
      state.packetsTrainingsList = action.payload;
    });
  },
});

export const { setPacketsTrainingsListLoading } = PacketsTrainingsSlice.actions;

export default PacketsTrainingsSlice.reducer;
